<template>
  <div class="layout--main">
    <the-steps-navbar class="mobile-hidden" :navbarColor="navbarColor" />

    <MobileNavbar class="sm:hidden" />

    <div id="content-edit__area">
      <div class="content-edit__wrapper">
        <div class="router-view">
          <div class="router-content mt-0">
            <transition :name="routerTransition" mode="out-in">
                <router-view></router-view>
            </transition>
          </div>
        </div>
      </div>
      <!-- <footer class="custom-footer min-w-full mobile-hidden">
        <span class="items-baseline pr-2">
            copyright @ {{ fullYear }} 
          <a href="#" target="_blank" rel="notfollow">Recrutei</a>
          , Todos os direitos reservados
        </span>
      </footer> -->
    </div>
  </div>
</template>

<script>
import TheStepsNavbar from '../components/TheStepsNavbar.vue';
import MobileNavbar from '../components/mobile-navbar/MobileNavbar';

export default {
    components: {
    TheStepsNavbar,
    MobileNavbar,
  }
}
</script>

<style lang="scss">
  #content-edit__area {
    max-height: calc(100vh - 62.38px);
    width: 100%;

    @media only screen and (max-width: 576px) {
      margin-left: 0;
      width: 100%;
      height: calc(100vh - 13rem)
    }

    .content-edit__wrapper {
      width: 100%;
      min-height: calc(100vh - 80.38px);

      @media only screen and (max-width: 576px) {
        min-height: calc(100vh - 13rem);
      }
    }

    .router-view {
      min-height: calc(100vh - 80.38px);
      padding: 0.55rem;

      @media only screen and (max-width: 576px) {
        // min-height: calc(100vh - 13rem);
        padding: .5rem !important;
      }
    }
  }

  .router-content {
    min-height: calc(100vh - 13rem);
  }

.router-content__area {
  width: 100%;
  height: calc(100vh - 79px);
  @media only screen and (max-width: 576px) {
    min-height: calc(100vh - 13rem);
  }
}

.buttons-footer {
  padding: 1rem 2.2rem;
}

.custom-footer {
  display: flex;
  justify-content: center;
}
</style>